<script>
import { required } from 'vuelidate/lib/validators'
import WorldMapAlarms from './world_map_alarms.vue'
import SearchInput from '@components/search-input.vue'
import SearchDateTime from '@components/search-datetime.vue'

// import appConfig from '@src/app.config'

import axios from 'axios'

export default {
  components: {
    WorldMapAlarms,
    SearchInput,
    SearchDateTime,
  },
  filters: {
    pretty: function(value) {
      return JSON.stringify(JSON.parse(value), null, 2)
    },
  },
  props: {
    url: {
      type: String,
      default: '/office365/alarms/list?',
    },
  },
  data() {
    return {
      appConfig: {},
      showDownloadCSVButton: false,
      category: 'List',
      items: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'Office 365 Alarms',
          active: true,
        },
      ],
      appConfig:
        process.env.NODE_ENV === 'production'
          ? require('@src/app.config')
          : require('@src/app.config.dev'),
      alarm: {},
      events: [],
      locations: [],
      tableData: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: '',
      fieldsFilter: '',
      // filterOn: [],
      sortBy: 'CreationTime',
      sortDesc: true,
      alarmDetailsFull: false,
      searchFields: '',
      showSearchByFields: true, // Cambiar a true para activar cambio de filtrado
      tableDetailFields: [
        { key: 'label', label: 'Field' },
        { key: 'visible', label: 'Visible' },
      ],
      fields: [
        {
          key: 'severity',
          field: 'severity',
          label: 'Severity',
          sortable: true,
          visible: true,
        },
        {
          key: 'type',
          field: 'type',
          label: 'Type',
          control: 'SearchInput',
          sortable: true,
          visible: true,
        },
        {
          key: 'target',
          field: 'target',
          label: 'Target',
          control: 'SearchInput',
          sortable: true,
          visible: true,
        },
        {
          key: 'message',
          field: 'message',
          label: 'Alarm',
          sortable: true,
          visible: true,
        },
        {
          key: 'start',
          field: 'start',
          label: 'Range Start',
          control: 'SearchDateTime',
          sortable: true,
          visible: true,
        },
        {
          key: 'end',
          field: 'end',
          label: 'Range End',
          control: 'SearchDateTime',
          sortable: true,
          visible: true,
        },
        { key: 'action', label: 'Action', sortable: false, visible: true },
      ],
      allFields: [
        {
          key: 'severity',
          field: 'severity',
          label: 'Severity',
          sortable: true,
          visible: true,
        },
        {
          key: 'type',
          field: 'type',
          label: 'Type',
          control: 'SearchInput',
          sortable: true,
          visible: true,
        },
        {
          key: 'target',
          field: 'target',
          label: 'Target',
          control: 'SearchInput',
          sortable: true,
          visible: true,
        },
        {
          key: 'message',
          field: 'message',
          label: 'Alarm',
          sortable: true,
          visible: true,
        },
        {
          key: 'start',
          field: 'start',
          label: 'Range Start',
          control: 'SearchDateTime',
          sortable: true,
          visible: true,
        },
        {
          key: 'end',
          field: 'end',
          label: 'Range End',
          control: 'SearchDateTime',
          sortable: true,
          visible: true,
        },
        {
          key: 'ip',
          field: 'raw_events.ClientIP',
          label: 'IP',
          control: 'SearchInput',
          sortable: false,
          visible: false,
        },
        {
          key: 'events',
          field: 'raw_events',
          label: 'Events',
          sortable: false,
          visible: false,
        },
      ],
      fieldsMapping: {
        type: 'type',
        target: 'target',
        ip: 'raw_events.ClientIP',
      },
      isBusy: true,
      searches: {},
      searchType: 'rawsearch',
    }
  },
  validations: {
    event: {
      title: { required },
      category: { required },
    },
  },
  computed: {
    rows() {
      return this.totalRows || 0
    },
  },
  watch: {
    currentPage: {
      handler: function(value) {
        this.loadData(this.filter)
      },
    },
    perPage: {
      handler: function(value) {
        this.loadData(this.filter)
      },
    },
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData(query = '') {
      const that = this
      that.showDownloadCSVButton = false
      that.isBusy = true
      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      const searchType = this.searchType
      const countURL =
        query.length < 1
          ? `${baseURL}${that.url}&count=yes`
          : `${baseURL}${that.url}&${searchType}=${query}&count=yes`

      axios
        .get(countURL)
        .then((response) => {
          that.totalRows = parseInt(response.data)
        })
        .catch(function(error) {})
      let dataURL =
        query.length < 1
          ? `${baseURL}${that.url}&page=${that.currentPage}&page_size=${
              that.perPage
            }`
          : `${baseURL}${that.url}&page=${that.currentPage}&page_size=${
              that.perPage
            }&${searchType}=${query}`
      axios
        .get(dataURL)
        .then((response) => {
          if (response.status === 200) {
            that.isBusy = false
            that.tableData = response.data.map(function(entry) {
              return {
                id: entry['_id'],
                type: entry.type || '',
                message: entry.message || '',
                severity: entry.severity || '',
                target: entry.target || '',
                start: new Date(entry.start['$date']).toLocaleString() || '',
                end: new Date(entry.end['$date']).toLocaleString() || '',
                events: entry.raw_events || [],
                // ip: [... new Set(entry.raw_events.map(item => item['ClientIP']))].join(', ') || '',
                ip: that.ipProcess(entry.raw_events) || '',
                locations: entry.locations || [],
              }
            })
          }
          that.showDownloadCSVButton = true
        })
        .catch(function(error) {})
    },
    generateCSV() {
      const that = this
      const separator = ';'
      const inKeys = [
        'severity',
        'type',
        'target',
        'start',
        'end',
        'message',
        'events',
      ]
      const outKeys = [
        'severity',
        'type',
        'target',
        'start',
        'end',
        'message',
        'events',
      ]
      const eventKeysIn = [
        'AppName',
        'Operation',
        'ResultStatus',
        'intelligence.geoip.country_name',
        'intelligence.geoip.city',
        'intelligence.geoip.ip',
        'intelligence.geoip.connection.asn',
        'CreationTime.$date',
      ]
      const eventKeysOut = {
        AppName: 'App Name',
        Operation: 'Operation',
        ResultStatus: 'Result Status',
        'intelligence.geoip.country_name': 'Country',
        'intelligence.geoip.city': 'City',
        'intelligence.geoip.ip': 'IP',
        'intelligence.geoip.connection.asn': 'ASN',
        'CreationTime.$date': 'Creation Time',
      }

      const headers = outKeys.join(separator) + '\n'
      let payload = that.tableData
        .map((entry) => {
          let procLine = inKeys
            .map((key) => {
              if (key !== 'events') {
                return entry[key] || ''
              } else {
                const rawEvents = entry[key] || []
                let eventC = 0

                const events = rawEvents.map((event) => {
                  const joinedEvent = eventKeysIn.map((eventKeyIn) => {
                    let e = ''
                    try {
                      e =
                        eventKeyIn.split('.').reduce((o, i) => o[i], event) ||
                        ''
                    } catch (err) {}
                    return ` ${eventKeysOut[eventKeyIn]}: ${e}`
                  })
                  eventC += 1
                  return ` Event ${eventC} => ${joinedEvent}`
                })
                return events
              }
            })
            .join(separator)
          return procLine
        })
        .join('\n')
      const csvContent = 'data:text/csv;charset=utf-8,' + headers + payload

      return csvContent
    },
    downloadCSV() {
      const that = this
      const content = that.generateCSV()
      let encodedUri = encodeURI(content)
      window.open(encodedUri)
    },
    ipProcess(data) {
      let out = []
      data.forEach((entry) => {
        if (out.some((e) => e.value === entry.ClientIP)) return
        out.push({
          value:
            entry !== undefined && entry.ClientIP !== undefined
              ? entry.ClientIP
              : 'N.A.',
          threat_level:
            entry !== undefined &&
            entry.intelligence !== undefined &&
            entry.intelligence.geoip !== undefined &&
            entry.intelligence.geoip !== null &&
            entry.intelligence.geoip.security !== undefined &&
            entry.intelligence.security !== null &&
            entry.intelligence.geoip.security.threat_level !== undefined
              ? entry.intelligence.geoip.security.threat_level
              : 'N.A.',
        })
      })
      return out
    },
    modalIncidentDetailOk() {
      this.alarm = {}
      this.events = []
      this.locations = []
    },
    showDetails(data) {
      if (data === undefined) return
      this.alarm.id = data.item.id
      this.alarm.target = data.item.target
      this.alarm.type = data.item.type
      this.alarm.message = data.item.message
      this.alarm.severity = data.item.severity

      this.events = data.item.events
      this.locations = data.item.locations
      this.$refs['modal-details'].show()
    },
    doSearch() {
      this.searchType = 'rawsearch'
      let filter = this.filter
      if (filter.length !== undefined) {
        this.loadData(filter)
      }
    },
    configTable() {
      this.$refs['modal-table-config'].show()
    },
    toggleVisibleColumn(data, selected) {
      const that = this
      // const visible = !selected.visible
      const visible = selected.visible // Arregló el problema que se presentaba con la interfaz

      if (visible) {
        if (
          that.fields.filter((field) => field.label === selected.label)
            .length === 0
        ) {
          let newFields = []
          that.allFields.forEach((af) => {
            if (af.label === selected.label) {
              newFields.push(selected)
            } else {
              if (
                that.fields.filter(
                  (field) => field.label === af.label && field.visible
                ).length > 0
              ) {
                newFields.push(af)
              }
            }
          })
          newFields.push({ key: 'action', sortable: false })
          that.fields = newFields
        }
      } else {
        if (
          that.fields.filter((field) => field.label === selected.label).length >
          0
        ) {
          let newFields = that.fields
          if (that.fields.length > 2)
            that.fields = newFields.filter(
              (field) => field.label !== selected.label
            )
          if (that.fieldsMapping[selected.key] !== undefined) {
            delete that.searches[that.fieldsMapping[selected.key]]
            that.doSearchInput()
          }
        }
      }
    },
    modalTableDetaillOk() {},
    aggEvents() {
      const that = this
      const ips = [...new Set(that.events.map((event) => event.ClientIP))]
      let agg = []
      ips.forEach((ip) => {
        let entries = that.events.filter((event) => event.ClientIP === ip)
        let count = entries.length
        let entryDetail = entries[0]
        entryDetail['events'] = count
        agg.push(entryDetail)
      })
      return agg
    },
    generateFilterFromFields() {
      const that = this
      let filter = ''
      Object.keys(that.searches).map((key) => {
        if (that.searches[key] !== undefined && that.searches[key].length > 0) {
          filter += `${key}:${that.searches[key]},`
        }
      })
      return filter.substring(0, filter.length - 1)
    },
    doSearchInput() {
      this.searchType = 'mfsearch'
      this.fieldsFilter = this.generateFilterFromFields()
      // console.log('filter', this.fieldsFilter)
      if (this.fieldsFilter.length !== undefined) {
        this.loadData(this.fieldsFilter)
      }
    },
    fieldSearchChanged(desc, field, text) {
      this.searches[field] = text.trim()
    },
    datetimeSearchChanged(desc, field, datetime) {
      this.searches[field] = datetime
    },
    async downloadCSVFull() {
      const that = this
      try {
        const baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
        const response = await axios.get(
          `${baseURL}/office365/alarms/list/csv?limit=2000&altorder=end&direction=desc`,
          {
            responseType: 'blob',
          }
        )

        const blob = new Blob([response.data], {
          type: 'text/csv;charset=utf-8;',
        })

        const link = document.createElement('a')
        const url = URL.createObjectURL(blob)

        link.setAttribute('href', url)
        link.setAttribute('download', 'alarms_list.csv')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
      } catch (error) {
        console.error('Error downloading the CSV file:', error)
      }
    },
  },
}
</script>

<template>
  <div>
    <div class="row mb-md-2">
      <div class="col-sm-6 col-md-6">
        <span>
          Alarms found:
          <b>
            {{ rows }}
          </b>
          at
          <b>
            {{ new Date().toLocaleString() }}
          </b>
        </span>
      </div>
      <!-- fields:
			{{  fields }}
			<br>
			allFields:
			{{  allFields }} -->
      <div class="col-sm-6 col-md-6">
        <div id="tickets-table_filter" class="dataTables_filter text-md-right">
          <label class="d-inline-flex align-items-center">
            <b-form-input
              v-model="filter"
              type="search"
              placeholder="Text to search..."
              class="form-control form-control-sm ml-2"
            />
            <b-button size="sm" variant="light" @click="doSearch">
              Search
            </b-button>
            <b-button size="sm" variant="light" @click="configTable">
              *
            </b-button>
          </label>
        </div>
      </div>
    </div>
    <div class="table-responsive mb-0">
      <b-table
        :items="tableData"
        :fields="fields"
        :busy="isBusy"
        responsive="sm"
        :per-page="0"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :total-rows="totalRows"
        :pagination-options="{
          enabled: true,
        }"
      >
        <template v-if="showSearchByFields" v-slot:thead-top="data">
          <b-tr>
            <b-th v-for="field in fields">
              <template v-if="field.control === 'SearchInput'">
                <SearchInput
                  :desc="field.key"
                  :field="field.field"
                  text=""
                  @updated="fieldSearchChanged"
                />
              </template>
              <template v-else-if="field.control === 'SearchDateTime'">
                <SearchDateTime
                  :desc="field.key"
                  :field="field.field"
                  text=""
                  @updated="datetimeSearchChanged"
                />
              </template>
              <template v-if="field.key === 'action'">
                <b-button @click="doSearchInput">
                  Search by fields
                </b-button>
              </template>
            </b-th>
          </b-tr>
        </template>
        <template v-slot:table-busy>
          <div class="text-center">
            <br /><br />
            <b-spinner class="align-middle" />
            <strong>&nbsp;&nbsp;Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(severity)="data">
          <template v-if="data.item.severity === 'low'">
            <feather type="alert-circle" class="icon-xs icon-dual-success" />
          </template>
          <template v-else-if="data.item.severity === 'medium'">
            <feather type="alert-triangle" class="icon-xs icon-dual-warning" />
          </template>
          <template v-else>
            <feather type="alert-octagon" class="icon-xs icon-dual-danger" />
          </template>
        </template>

        <template v-slot:cell(ip)="data">
          <template v-for="ip in data.item.ip">
            <template v-if="ip.threat_level === 'high'">
              <span :class="'severity-' + ip.threat_level"
                >{{ ip.value }}&nbsp;</span
              >
            </template>
            <template v-else-if="ip.threat_level === 'medium'">
              <span :class="'severity-' + ip.threat_level"
                >{{ ip.value }}&nbsp;</span
              >
            </template>
            <template v-else-if="ip.threat_level === 'low'">
              <span :class="'severity-' + ip.threat_level"
                >{{ ip.value }}&nbsp;</span
              >
            </template>
            <template v-else>
              {{ ip.value }}
            </template>
          </template>
        </template>

        <template v-slot:cell(creation_time)="data">
          {{ data.item.creation_time }}
        </template>
        <template v-slot:cell(events)="data">
          {{ data.item.events.length }}
        </template>
        <template v-slot:cell(locations)="data">
          {{ data.item.locations.length }}
        </template>
        <template v-slot:cell(action)="data">
          <b-dropdown
            right
            variant="white"
            class="align-self-center"
            toggle-class="p-0"
          >
            <template v-slot:button-content>
              <feather
                type="chevron-down"
                class="align-middle"
                style="height:12px !important;width:20px !important;"
              />
            </template>
            <b-dropdown-item class="notify-item" @click="showDetails(data)">
              <feather
                type="search"
                class="icon-dual icon-xs mr-2 align-middle"
              />
              <span>Details</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <div id="tickets-table_length" class="dataTables_length">
          <label class="d-inline-flex align-items-center">
            Show&nbsp;
            <b-form-select
              v-model="perPage"
              size="sm"
              :options="pageOptions"
            />&nbsp;entries
          </label>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <b-button
            v-if="showDownloadCSVButton"
            size="sm"
            variant="light"
            @click="downloadCSV"
          >
            Download CSV
          </b-button>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <b-button
            v-if="showDownloadCSVButton"
            size="sm"
            variant="light"
            @click="downloadCSVFull"
          >
            Download CSV File (max 2000 entries)
          </b-button>
        </div>
      </div>
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-right">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
            />
          </ul>
        </div>
      </div>
    </div>
    <b-modal
      id="incident.incident_id"
      ref="modal-details"
      size="xl"
      title="Alarm Details"
      :centered="true"
      :no-fade="true"
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      ok-only
      @ok="modalIncidentDetailOk"
    >
      <div>
        <span
          ><span class="varname">Target:&nbsp;</span
          ><span class="varcontent">{{ alarm.target }}</span></span
        >
      </div>
      <div>
        <span
          ><span class="varname">Type:&nbsp;</span
          ><span class="varcontent">{{ alarm.type }}</span></span
        >
      </div>
      <div>
        <!-- <template v-if="alarm.type==='Audit activity'">
          ABC DEF
        </template> -->
        <template>
          <span
            ><span class="varname">Severity:&nbsp;</span>
            <template v-if="alarm.severity === 'high'">
              <span class="varcontent" :class="'severity-' + alarm.severity">{{
                alarm.severity
              }}</span>
            </template>
            <template v-else-if="alarm.severity === 'medium'">
              <span class="varcontent" :class="'severity-' + alarm.severity">{{
                alarm.severity
              }}</span>
            </template>
            <template v-else-if="alarm.severity === 'low'">
              <span class="varcontent" :class="'severity-' + alarm.severity">{{
                alarm.severity
              }}</span>
            </template>
          </span>
        </template>
      </div>
      <div>
        <span
          ><span class="varname">Message:&nbsp;</span
          ><span class="varcontent">{{ alarm.message }}</span></span
        >
      </div>
      <div role="tablist" class="custom-accordionwitharrow">
        <template v-if="locations !== undefined && locations.length > 0">
          <a v-b-toggle.collapse-assets href="#" class="text-dark">
            <h5 class="mb-0">
              <feather type="chevron-down" class="align-middle" />
              Locations
              <span class="text-muted font-size-14"
                >({{ locations.length }})</span
              >
            </h5>
          </a>
          <b-collapse id="collapse-assets" visible>
            <div style="align:center">
              <table style="width:100%">
                <tr>
                  <td style="width: 50%">
                    <ul>
                      <li v-for="loc in locations">
                        {{ loc.country }},
                        {{ loc.city }}
                      </li>
                    </ul>
                  </td>
                  <td style="padding-right:30px;">
                    <WorldMapAlarms :locations="locations" />
                  </td>
                </tr>
              </table>
            </div>
          </b-collapse>
        </template>

        <template v-if="events !== undefined">
          <a v-b-toggle.collapse-assets href="#" class="text-dark">
            <h5 class="mb-0">
              <feather type="chevron-down" class="align-middle" />
              Events
              <span class="text-muted font-size-14">({{ events.length }})</span>
            </h5>
          </a>
          <b-collapse id="collapse-assets" visible>
            <!-- <template v-if="events.length === 1 && events[0].intelligence === undefined">
							<pre>
								{{ events[0] }}
							</pre>
						</template> -->
            <template
              v-if="
                alarm.type === 'Business Email Compromise' ||
                  alarm.type === 'Audit activity'
              "
            >
              <pre>
								{{ events }}
							</pre
              >
            </template>
            <template v-else>
              <table width="100%" style="border:1px;">
                <thead>
                  <template v-if="alarmDetailsFull">
                    <th>Date / Time</th>
                    <th>Operation</th>
                    <th>Result Status</th>
                    <th>Client IP</th>
                    <th>Country</th>
                    <th>City</th>
                    <th>ASN</th>
                    <th>ISP</th>
                  </template>
                  <template v-else>
                    <th>Client IP</th>
                    <th>Operation</th>
                    <th>Result Status</th>
                    <th>Country</th>
                    <th>City</th>
                    <th>ASN</th>
                    <th>ISP</th>
                    <th>Events</th>
                  </template>
                </thead>
                <tbody>
                  <template v-if="alarmDetailsFull">
                    <tr v-for="(event, index) in events" :key="index">
                      <td>{{
                        new Date(event.CreationTime['$date']).toLocaleString()
                      }}</td>
                      <template
                        v-if="
                          event.intelligence !== undefined &&
                            event.intelligence.geoip !== undefined
                        "
                      >
                        <td>
                          <template
                            v-if="
                              event.intelligence.geoip.security.threat_level ===
                                'high'
                            "
                          >
                            <span
                              :class="
                                'severity-' +
                                  event.intelligence.geoip.security.threat_level
                              "
                              >{{ event.ClientIP }}</span
                            >
                          </template>
                          <template
                            v-else-if="
                              event.intelligence.geoip.security.threat_level ===
                                'medium'
                            "
                          >
                            <span
                              :class="
                                'severity-' +
                                  event.intelligence.geoip.security.threat_level
                              "
                              >{{ event.ClientIP }}</span
                            >
                          </template>
                          <template
                            v-else-if="
                              event.intelligence.geoip.security.threat_level ===
                                'low'
                            "
                          >
                            <span
                              :class="
                                'severity-' +
                                  event.intelligence.geoip.security.threat_level
                              "
                              >{{ event.ClientIP }}</span
                            >
                          </template>
                        </td>
                        <td>{{ event.Operation || 'N.A.' }}</td>
                        <td>{{ event.ResultStatus || 'N.A.' }}</td>
                        <td
                          >{{
                            event.intelligence.geoip.location
                              .country_flag_emoji || ''
                          }}
                          {{
                            event.intelligence.geoip.country_name || 'N.A.'
                          }}</td
                        >
                        <td>{{ event.intelligence.geoip.city || 'N.A.' }}</td>
                        <template
                          v-if="
                            event.intelligence.geoip.connection !== undefined
                          "
                        >
                          <td>{{
                            event.intelligence.geoip.connection.asn || 'N.A.'
                          }}</td>
                          <td>{{
                            event.intelligence.geoip.connection.isp || 'N.A.'
                          }}</td>
                        </template>
                      </template>
                    </tr>
                  </template>
                  <template v-else>
                    <tr v-for="(event, index) in aggEvents()" :key="index">
                      <template
                        v-if="
                          event.intelligence !== undefined &&
                            event.intelligence.geoip !== undefined
                        "
                      >
                        <td>
                          <template
                            v-if="
                              event.intelligence.geoip.security.threat_level ===
                                'high'
                            "
                          >
                            <span
                              :class="
                                'severity-' +
                                  event.intelligence.geoip.security.threat_level
                              "
                              >{{ event.ClientIP }}</span
                            >
                          </template>
                          <template
                            v-else-if="
                              event.intelligence.geoip.security.threat_level ===
                                'medium'
                            "
                          >
                            <span
                              :class="
                                'severity-' +
                                  event.intelligence.geoip.security.threat_level
                              "
                              >{{ event.ClientIP }}</span
                            >
                          </template>
                          <template
                            v-else-if="
                              event.intelligence.geoip.security.threat_level ===
                                'low'
                            "
                          >
                            <span
                              :class="
                                'severity-' +
                                  event.intelligence.geoip.security.threat_level
                              "
                              >{{ event.ClientIP }}</span
                            >
                          </template>
                        </td>
                        <td>{{ event.Operation || 'N.A.' }}</td>
                        <td>{{ event.ResultStatus || 'N.A.' }}</td>
                        <td
                          >{{
                            event.intelligence.geoip.location
                              .country_flag_emoji || ''
                          }}
                          {{
                            event.intelligence.geoip.country_name || 'N.A.'
                          }}</td
                        >
                        <td>{{ event.intelligence.geoip.city || 'N.A.' }}</td>
                        <template
                          v-if="
                            event.intelligence.geoip.connection !== undefined
                          "
                        >
                          <td>{{
                            event.intelligence.geoip.connection.asn || 'N.A.'
                          }}</td>
                          <td>{{
                            event.intelligence.geoip.connection.isp || 'N.A.'
                          }}</td>
                        </template>
                      </template>
                      <td>{{ event.events || 0 }}</td>
                    </tr>
                  </template>
                  <b-form-checkbox
                    v-model="alarmDetailsFull"
                    name="check-button-adf"
                    switch
                  >
                    Alarm Details Full
                  </b-form-checkbox>
                </tbody>
              </table>
            </template>
            <!-- <pre>
						{{ events || pretty }}
						</pre> -->
          </b-collapse>
        </template>
      </div>
    </b-modal>
    <b-modal
      id="table_config"
      ref="modal-table-config"
      size="xl"
      title="Events Table Config"
      :centered="true"
      :no-fade="true"
      ok-only
      @ok="modalTableDetaillOk"
    >
      <b-table :items="allFields" :fields="tableDetailFields" responsive="sm">
        <template v-slot:cell(visible)="data">
          <template v-for="field in allFields">
            <template v-if="data.item.label === field.label">
              <b-form-checkbox
                v-model="field.visible"
                name="check-button"
                switch
                @change="toggleVisibleColumn(data.item, field)"
              />
            </template>
          </template>
        </template>
      </b-table>
    </b-modal>
  </div>
</template>

<style>
.incident-status {
  width: 15%;
}
.incident-description {
  width: 35%;
}
.varname {
  font-size: 1.2em;
  font-weight: 700;
}
.varcontent {
  font-size: 1.2em;
  font-weight: 200;
}
.severity-high {
  color: #dc001e;
}
.severity-medium {
  color: #feca00;
}
.severity-low {
  color: #01ad00;
}
</style>
